// @ts-nocheck
import useFilteredVariantTraits from "@insite/client-framework/Common/Hooks/useFilteredVariantTraits";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import updateVariantSelection from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import { VariantDisplayTypeValues, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
// import ProductDetailsVariantButton from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantButton";
import ProductDetailsVariantDropdown from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantDropdown";
import ProductDetailsVariantSwatchDropdown from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchDropdown";
// import ProductDetailsVariantSwatchGrid from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchGrid";
import ProductDetailsVariantSwatchList from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchList";
import Select, { SelectProps } from "@insite/mobius/Select";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Valtech Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link/Link";
import getColor from "@insite/mobius/utilities/getColor";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import { productDetailsFormWrapperStyles } from "@store/Themes/common/mixins/productDetails";
import { formSmallGridProps } from "@store/Themes/common/props/form";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { swatchProps } from "@store/Themes/common/props/swatch";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Valtech Custom Code - End */

// Foundation --->
import useDisableOutOfStockVariants from "@store/Framework/Store/Foundation/Data/Products/ProductsHooks/useDisableOutOfStockVariants";
import ProductDetailsVariantButton from "@store/Overrides/Widgets/ProductDetails/ProductDetailsVariantButton";
import ProductDetailsVariantSwatchGrid from "@store/Overrides/Widgets/ProductDetails/ProductDetailsVariantSwatchGrid";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { productNumbers } from "@store/Themes/common/props/product";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { IconWrapper } from "@insite/mobius/Icon";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
// bunzl custom code
import useVariantParams from "@store/Framework/Common/Hooks/Pages/QuickOrder/ProductDetails/useVariantParams";

const enum fields {
    disableOutOfStockVariants = "disableOutOfStockVariants",
    // bunzl custom code
    disableSwatchGrid = "disableSwatchGrid",
}

interface OwnProps {
    fields: {
        // bunzl custom code
        [fields.disableSwatchGrid]: boolean;
        [fields.disableOutOfStockVariants]: boolean;
    };
}

// <--- Foundation

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasParentProductId &
    // Foundation
    OwnProps;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({
    variantTraits: getProductState(state, ownProps.parentProductId).value?.variantTraits,
    variantChildren: getVariantChildrenDataView(state, ownProps.parentProductId).value,
    variantSelection: state.pages.productDetails.variantSelection,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    variantProductState: getProductState(state, state.pages.productDetails.selectedProductId),
    selectedProductId: state.pages.productDetails.selectedProductId,
});

const mapDispatchToProps = {
    updateVariantSelection,
    loadRealTimeInventory,
};

export interface ProductDetailsVariantOptionsStyles {
    wrapper?: InjectableCss;
    select?: SelectProps;
    // Foundation
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
}

export const variantOptionsStyles: ProductDetailsVariantOptionsStyles = {
    wrapper: {
        css: css`
            width: 80%;
            max-width: ${pxToRem(335)};
            // bunzl custom code
            display: grid;
            gap: 1rem;
        `,
    },
    select: {
        cssOverrides: {
            formField: css`
                ${contentSpacingStyles(0, 0, pxToRem(15))}
            `,
            formInputWrapper: css`
                margin-top: ${pxToRem(10)} !important;

                ${IconWrapper} {
                    color: ${getColor("primary")};
                }
            `,
            inputSelect: css`
                padding-right: 2em;
                text-overflow: ellipsis;

                &:focus,
                &:active {
                    padding-right: 2em;
                    border: ${pxToRem(2)} solid ${getColor("primary")};
                }
            `,
        },
    },
    labelText: {
        ...productNumbers.labelText,
        transform: "none",
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.base};
        `,
    },
    valueText: {
        ...productNumbers.valueText,
        transform: "none",
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.base};
        `,
    },
    gridContainer: formSmallGridProps.gridContainer,
    gridItem: { width: 12 },
};

const styles = variantOptionsStyles;

export const ProductDetailsVariantOptions: React.FC<Props> = ({
    variantChildren,
    variantSelection,
    updateVariantSelection,
    variantTraits,
    parentProductId,
    variantProductState,
    selectedProductId,
    // Foundation
    loadRealTimeInventory,
    fields,
    // Bunzl custom code
}) => {
    // bunzl custom code, derived state
    // const [filteredVariantTraits, setFilteredVariantTraits] = React.useState<VariantTraitModel[]>();
    const { disableSwatchGrid } = fields;
    const [inventory, setInventory] = React.useState<{ [key: string]: number }>({});
    const [isLoading, setIsLoading] = React.useState(false);

    const isSwatch = variantTraits?.some(
        x => x.displayType === VariantDisplayTypeValues.SwatchGrid || x.displayType === VariantDisplayTypeValues.Button,
    );

    const DisableSelection = (variantId: string): boolean => {
        const filtered = variantTraits
            ?.filter(variant => variant.id === variantId)
            .map(traits => traits.traitValues)[0];
        // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
        return filtered?.length! === 1;
    };
    // <-- Foundation

    // bunzl custom code
    useVariantParams(parentProductId, variantTraits ?? []);
    useEffect(() => {
        let newUrl = window.location.href.split("?option=")[0];
        if (variantProductState.value?.isVariantParent) {
            window.history.replaceState(null, "", newUrl);
        } else if (variantProductState.value?.childTraitValues) {
            newUrl = newUrl.concat("?option=", variantProductState.value.urlSegment);
            window.history.replaceState(null, "", newUrl);
        }
    }, [selectedProductId]);

    // Foundation -->
    useEffect(() => {
        const loadInventory = () => {
            setIsLoading(true);
            const productIds = variantChildren?.map(o => o.id) ?? [];
            loadRealTimeInventory({
                productIds,
                onSuccess: result => {
                    result.realTimeInventoryResults?.forEach(product => {
                        setInventory(inventory => ({ ...inventory, [product.productId]: product.qtyOnHand }));
                    });
                    setIsLoading(false);
                },
            });
        };
        if (isSwatch && fields.disableOutOfStockVariants) {
            loadInventory();
        }
    }, []);
    // bunzl custom code removed use effects but kept logic consistent with foundation --->
    let filteredVariantTraits = useFilteredVariantTraits(variantTraits ?? [], variantChildren ?? [], variantSelection);
    const filteredVariantTraitsOutOfStock = useDisableOutOfStockVariants(
        inventory,
        variantTraits!,
        variantChildren!,
        variantSelection,
    );
    const swatchFilteredVariantTraints = useFilteredVariantTraits(
        filteredVariantTraitsOutOfStock,
        variantChildren ?? [],
        variantSelection,
    );
    // <---
    const variantChangeHandler = (traitValueId: string, variantTraitId: string) => {
        updateVariantSelection({ traitValueId, variantTraitId, productId: parentProductId });
    };

    if (!variantTraits || variantTraits.length === 0 || !variantChildren) {
        return null;
    }
    if (disableSwatchGrid) {
        filteredVariantTraits = filteredVariantTraits.map(variantTrait => {
            return { ...variantTrait, displayType: VariantDisplayTypeValues.Dropdown };
        });
    }
    const renderVariant = (variantTrait: VariantTraitModel) => {
        const swatchVariant = swatchFilteredVariantTraints.find(x => x.id === variantTrait.id);
        switch (variantTrait.displayType) {
            case VariantDisplayTypeValues.Button:
                return (
                    <ProductDetailsVariantButton
                        key={variantTrait.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={variantTrait}
                        // Foundation -->
                        disableClearSelection={DisableSelection(variantTrait.id)}
                        // <-- Foundation
                    />
                );
            case VariantDisplayTypeValues.SwatchDropdown:
                if (!swatchVariant) {
                    return null;
                }
                return (
                    <ProductDetailsVariantSwatchDropdown
                        key={swatchVariant.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={swatchVariant}
                    />
                );
            case VariantDisplayTypeValues.SwatchGrid:
                if (!swatchVariant) {
                    return null;
                }
                return (
                    <ProductDetailsVariantSwatchGrid
                        key={swatchVariant.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={swatchVariant}
                        // Foundation -->
                        disableClearSelection={DisableSelection(variantTrait.id)}
                        // <-- Foundation
                    />
                );
            case VariantDisplayTypeValues.SwatchList:
                if (!swatchVariant) {
                    return null;
                }
                return (
                    <ProductDetailsVariantSwatchList
                        key={swatchVariant.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={swatchVariant}
                    />
                );
            default:
                return (
                    <ProductDetailsVariantDropdown
                        key={variantTrait.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={variantTrait}
                    />
                );
        }
    };

    // Foundation -->
    if (isSwatch) {
        if (isLoading) {
            return (
                <StyledWrapper>
                    <LoadingSpinner />
                </StyledWrapper>
            );
        }
        return (
            <StyledWrapper {...styles.wrapper}>
                <GridContainer {...styles.gridContainer}>
                    {filteredVariantTraits?.map(
                        variantTrait =>
                            !!variantTrait.traitValues?.length && (
                                <GridItem key={variantTrait.id} {...styles.gridItem}>
                                    {/* bunzl custom code removed unnecessary cast */}
                                    {renderVariant(variantTrait)}
                                </GridItem>
                            ),
                    )}
                </GridContainer>
            </StyledWrapper>
        );
    }
    // <-- Foundation

    return (
        <StyledWrapper {...styles.wrapper}>
            {filteredVariantTraits?.map(
                // bunzl custom code removed unnecessary cast as optional chaining is used
                variantTrait => !!variantTrait.traitValues?.length && renderVariant(variantTrait),
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withParentProductId(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsVariantOptions)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        // Foundation --->
        fieldDefinitions: [
            {
                name: fields.disableOutOfStockVariants,
                displayName: "Disables the variants that are out of stock.",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
        ],
        // <--- Foundation
    },
};

export default widgetModule;
